import React, { Component } from "react";
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import Swal from "sweetalert2";
//Miscellaneous
import moment from "moment";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { Fade, Reveal } from "react-awesome-reveal";
import { keyframes } from "@emotion/react";
import { default as ReactSelect } from "react-select";

//Components
import DateTimePicker from "../../components/DateTimePicker/DateTimePicker";
import DataTable from "../../components/Datatable/DataTable";
import SideBar from "../../components/Sidebar/Sidebar";
import Button from "../../components/Button/Button";
import { isDesktop } from "react-device-detect";

//Icons
import { Icon } from "@iconify/react";

// Actions
import * as actions from "../../store/ducks/bettingHistory/actions";
import MobileBettingHistory from "./MobileBettingHistory";

const gameCategories = [
    { id: "filterAll", value: "", label: "All" },
    { id: "filterLC", value: "ca", label: "Live Casino" },
    { id: "filterSports", value: "sp", label: "Sport" },
    { id: "filterSlots", value: "sl", label: "Slots" },
    { id: "filterGames", value: "ga", label: "Games" },
    { id: "filterP2P", value: "p2", label: "P2P" },
    { id: "filterLottery", value: "ke", label: "Lottery" },
];

const filterDate = [
    { id: "filterToday", value: "0", label: "today" },
    { id: "filterYtd", value: "1", label: "yesterday" },
    { id: "filter7Day", value: "7", label: "last-7-days" },
    { id: "filter30Days", value: "30", label: "last-30-days" },
];

const gameProviders = [
    { id: "all", value: "all", label: "All", icon: "" },
    { id: "filterAb", value: "ab", label: "ALLBET", icon: "ab-icon.png" },
    { id: "filterAg", value: "ag", label: "ASIA GAMING", icon: "ag-icon.png" },
    { id: "filterEa", value: "ea", label: "EA GAMING", icon: "ea-icon.png" },
    { id: "filterEvo", value: "evo", label: "EVOLUTION GAMING", icon: "evo-icon.png" },
    { id: "filterGpi", value: "gp", label: "GAMEPLAY INT", icon: "gpi-icon.png" },
    { id: "filterIsb", value: "isb", label: "I SOFT BET", icon: "isb-icon.png" },
    { id: "filterMg", value: "mg", label: "MICRO GAMING", icon: "mg-icon.png" },
    { id: "filterNet", value: "net", label: "NETENT", icon: "net-icon.png" },
    { id: "filterPp", value: "pp", label: "PRAGMATIC PLAY", icon: "pp-icon.png" },
    { id: "filterPt", value: "pt", label: "PLAYTECH", icon: "pt-icon.png" },
    { id: "filterQt", value: "qt", label: "QTECH", icon: "qt-icon.png" },
    { id: "filterSa", value: "sa", label: "SA GAMING", icon: "sa-icon.png" },
    { id: "filterSb", value: "sb", label: "SABA", icon: "sb-icon.png" },
    { id: "filterSbo", value: "sbo", label: "SBOBET", icon: "sbo-icon.png" },
    { id: "filterSg", value: "sg", label: "SPADE GAMING", icon: "sg-icon.png" },
    { id: "filterSp", value: "sp", label: "SIMPLE PLAY", icon: "sp-icon.png" },
    { id: "filterTtg", value: "ttg", label: "TOP TREND GAMING", icon: "ttg-icon.png" },
    { id: "filterQs", value: "qs", label: "QUICKSPIN", icon: "qs-icon.png" },
    { id: "filterDg", value: "dg", label: "DREAM GAMING", icon: "dg-icon.png" },
    { id: "filterPng", value: "png", label: "PLAYNGO", icon: "png-icon.png" },
]

const options = [
    { value: "all", label: "All" },
    { value: "unsettlement", label: "Unsettlement" },
    { value: "settled", label: "Settled" },
    { value: "canceled", label: "Canceled" },
    { value: "invalid", label: "Invalid" },
  ];

class BettingHistory extends Component {
    constructor(props) {
        super(props);
        this.state =
        {
            selectedFilterType: '',
            historyTab: 'betting_summary',
            start_date: moment().format("YYYY-MM-DD"),
            end_date: moment().format("YYYY-MM-DD"),
            currentFilterDate: 0,
            transaction_date: '',
            game_type: '',

            /* datatables / pagination */
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            totalRecords: 0,

            /* api result array */
            data: [],
            total: [],
            downline: [],

            /* skeleton loading */
            loading: true,
            dates: null,

            /* mobile */
            showDateSelect: false,
            showDate: '',
            selectedDate: '',
            mobileOpts: "",

            spin: false,

            /* game provider */
            game_provider: '',

            refer_member: '',
            selectedMember: null,

            // Lazy loading states for member dropdown
            memberOptions: [],
            allMembers: [], // Store all members for pagination
            memberPage: 1,
            memberLimit: 50, // load how many members each time
            initialLoadLimit: 50, // Initial load limit for first load
            memberLoading: false,
            memberLoadingMore: false,
            memberHasMore: true,
            memberSearch: '',

            errorMsg: [],
        };
        this.onInputChange = this.onInputChange.bind(this);
        this.searchTimeout = null;
    }

    componentWillUnmount() {
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }
    }

    componentDidMount() {
        this.props.fetchUserBasicsFromLocal().then(() => {
            this.tryInit();
        });
    }

    componentDidUpdate(prevProps) {
        if ((prevProps.userBasics?.id !== this.props.userBasics?.id) ||
            (prevProps.userBasics?.merchant_id !== this.props.userBasics?.merchant_id)) {
            this.tryInit();
        }
    }




    tryInit = () => {
        const u = this.props.userBasics || {};
        const hasUser = (u.id || u.aid || u.agent_id) && (u.merchant_id || u.merchantId);
        if (!hasUser) return;

        const listingArr = this.getFilterArray();
        this.props.funcGetList(listingArr);

        this.props.funcGetDropDown({
            id: u.id || u.aid || u.agent_id,
            merchant_id: u.merchant_id || u.merchantId,
        });
    }


    onMenuScrollToBottom = () => {
        this.loadNextPage();
    }

    // Simple scrollbar detection
    onMenuScroll = (event) => {
        const { scrollTop, scrollHeight, clientHeight } = event.target;
        if (scrollTop + clientHeight >= scrollHeight - 10) {
            this.loadNextPage();
        }
    }

    // Direct scrollbar detection when menu opens
    onMenuOpen = () => {
        setTimeout(() => {
            const menuList = document.querySelector('.react-select__menu-list');
            if (menuList) {
                menuList.addEventListener('scroll', () => {
                    const { scrollTop, scrollHeight, clientHeight } = menuList;
                    if (scrollTop + clientHeight >= scrollHeight - 10) {
                        this.loadNextPage();
                    }
                });
            }
        }, 100);
    }

    loadNextPage = () => {
        if (this.state.memberLoading || this.state.memberLoadingMore || !this.state.memberHasMore) return;

        this.setState({ memberLoadingMore: true });

        setTimeout(() => {
            const nextPage = this.state.memberPage + 1;
            const startIndex = (nextPage - 1) * this.state.memberLimit;
            const endIndex = startIndex + this.state.memberLimit;
            
            const nextBatch = this.state.allMembers.slice(startIndex, endIndex);
            
            this.setState({
                memberOptions: [...this.state.memberOptions, ...nextBatch],
                memberPage: nextPage,
                memberHasMore: endIndex < this.state.allMembers.length,
                memberLoadingMore: false
            });
        }, 500);
    }

    onInputChangeMember = (inputValue) => {
        this.setState({ memberSearch: inputValue });
        
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
            this.performMemberSearch(inputValue);
        }, 300);
    }

    performMemberSearch = (searchTerm) => {
        if (!searchTerm || searchTerm.trim() === '') {
            this.resetToFirstPage();
            return;
        }
        const filtered = this.state.allMembers.filter(member => 
            member.label.toLowerCase().includes(searchTerm.toLowerCase())
        );
        
        this.setState({ memberOptions: filtered });
    }

    resetToFirstPage = () => {
        const firstPageOptions = this.state.allMembers.slice(0, this.state.initialLoadLimit);
        this.setState({
            memberOptions: firstPageOptions,
            memberPage: 1,
            memberHasMore: this.state.allMembers.length > this.state.initialLoadLimit,
            memberLoadingMore: false
        });
    }
    
    shouldComponentUpdate(nextProps, nextState) {
        const { t } = this.props;
        if (nextProps.rs !== this.props.rs && nextProps.rs !== undefined) {
            if (nextProps.rs.responseCode === 200 && nextProps.rs.msgType === 'success') {
                this.setState({
                    data: nextProps.rs.data.result.row,
                    totalRecords: nextProps.rs.data.result.pagination.total_record,
                    loading: false,
                    total: nextProps.rs.data.total,
                    disableSearchButton: false,
                });
            } else {
                let msg = null;
                msg = "<div>";
                nextProps.rs.message.forEach((val) => {
                    msg += "<p>" + val + "</p>";
                });
                msg += "</div>";

                Swal.fire({
                    iconHtml: !isDesktop ? '<img src="https://api.iconify.design/fa6-solid:face-sad-tear.svg?color=%23b0b0b0">' : "",
                    icon: "error",
                    title: t("global.sorry"),
                    html: msg,
                    showConfirmButton: true,
                    confirmButtonText: t("global.ok"),
                    customClass: !isDesktop
                        ? {
                                container: "swal-mobile-container sorry",
                                icon: "swal-sorry-icon",
                            }
                        : [],
                }).then(() => {
                    this.setState({
                        loading: false,
                        disableSearchButton: false,
                    });
                });
            }
        }

        if (nextProps.dropDown !== this.props.dropDown && nextProps.dropDown !== undefined)  {
            if (nextProps.dropDown.responseCode === 200 && nextProps.dropDown.msgType === "success") 
            {
                const allMembers = nextProps.dropDown.data.downline || [];
                
                const allOptions = allMembers.map((u) => ({
                    value: u.username,
                    label: u.username,
                    id: u.id,
                }));

                // Load initial members (configurable from state)
                const firstPageOptions = allOptions.slice(0, this.state.initialLoadLimit);
                
                this.setState({
                    downline: allMembers,
                    allMembers: allOptions,
                    memberOptions: firstPageOptions,
                    memberPage: 1,
                    memberHasMore: allOptions.length > this.state.initialLoadLimit,
                    memberLoading: false
                });
            }
        }


        return true;
    }

    imageImport = (r) => {
        let images = {};
        r.keys().map((item, index) => {
            return (images[item.replace("./", "")] = r(item)["default"]);
        });
        return images;
    }

    submitHandler = (e) => {
        e.preventDefault();

        const { t } = this.props;
        Swal.fire({
            title: t("validation.confirmation"),
            text: t("global.would-you-like-to-proceed") + "?",
            icon: "warning",
            confirmButtonText: t("global.confirm"),
            showDenyButton: true,
            denyButtonText: t("global.cancel"),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });

                const inputArr = {};

                Object.keys(this.state.input).forEach((val) => {
                    if(this.state.withdrawalOption === 'crypto'){
                        inputArr['amount'] = this.state.input['cryptoAmount'];
                        inputArr['transaction_channel_id'] = this.state.input['transaction_channel_id'];
                        inputArr.crypto = this.state.cryptoOption;
                        inputArr.withdrawal_address = (this.state.selectWithdrawalCryptoAddr.value || '');
                    }else{
                        inputArr[val] = this.state.input[val]
                    }
                });

                this.props.funcStore(inputArr);
            }
        });
    };

    onInputChange = (event) => {
        this.setState({
            selectedFilterType: event.target.value
        });
        if (event.target.id === 'transaction_date') {
            const date = (event.target.value !== '') ? event.target.value.split(" - ") : null;
            this.setState({
                start_date: (date[0]) ? moment(date[0]).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
                end_date: (date[1]) ? moment(date[1]).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
                transaction_date: event.target.value,
            });

            const startDate = moment(this.state.start_date);
            const endDate = moment(this.state.end_date);
            const diff = endDate.diff(startDate, 'days');

            // Only allow to get data between 3 months
            if (diff > 92) {
                this.setState({
                    disableSearchButton: true
                })
            } else {
                this.setState({
                    disableSearchButton: false
                })
            }
        }
        else {
            this.setState({
                [event.target.name]: event.target.value,
            });
        }
    }

    handleGameProviderChange = (e) => {
        let value = e.value || e.target.defaultValue;

        if (this.state.game_provider !== value) {
            this.setState({
                game_provider: value,
            }, () => {
                this.searchHandler();
            });
        }
    }

    handleMemberReferChange = (e) => {
        // let value = e.value || e.target.defaultValue;
        // if (this.state.refer_member !== value) {
        //     this.setState({
        //         refer_member: value,
        //     }, () => {
        //         this.searchHandler();
        //     });
        // }else{

            this.setState({
                memberId: e.id,
                refer_member: e.label,
                mobileOpts: e !== null && e.id > 0 ? e : "",
            });
        // }
    }

    searchHandler = () => {
        this.setState({
            activePage: 1,
            data: [],
            loading: true,
            disableSearchButton: true
        }, () => {
            const listingArr = this.getFilterArray();
            this.props.funcGetList(listingArr);

            const userInfoArr = this.userInfoArray();
            this.props.funcGetDropDown(userInfoArr);
        });
    }
    
    filterDayRange = (val) => {
        // let days = Number(event.target.value);
        let days = val;
        let startDate = moment().subtract(days, "days").format("YYYY-MM-DD");
        let endDate = moment().format("YYYY-MM-DD");
        let transactionDate = `${moment(startDate).format("MM/DD/YYYY")} - ${moment(endDate).format("MM/DD/YYYY")}`;

        this.setState({
            start_date: startDate,
            end_date: endDate,
            transaction_date: transactionDate,
            filterRange: days
        }, () => {
            let startDate = moment(this.state.start_date);
            let endDate = moment(this.state.end_date);
            let dayRange = endDate.diff(startDate, 'days');
            let disableButton = null;
            if (!startDate.isSameOrBefore(endDate) || !endDate.isSameOrAfter(startDate) || dayRange > 92) {
                disableButton = true;
            } else {
                disableButton = false;
                const listingArr = this.getFilterArray(this.state.historyTab);
                this.props.funcGetList(listingArr);

                const userInfoArr = this.userInfoArray(this.state.historyTab);
                this.props.funcGetDropDown(userInfoArr);
            }
            this.setState({
                disableSearchButton: disableButton
            })

            this.searchHandler();
        });
    }

    getFilterArray = () => {
        const listingArr = {};
        listingArr.page = this.state.activePage;
        listingArr.limit = this.state.limit;
        // listingArr.order = JSON.stringify(this.state.order);
        listingArr.start_date = this.state.start_date;
        listingArr.end_date = this.state.end_date;
        listingArr.game_type = this.state.game_type;
        listingArr.country_id = this.props.currentUser.country_id;
        //listingArr.lang_id = this.props.currentUser.language_id;
        // listingArr.transaction_type = this.state.historyTab;
        listingArr.game_provider = this.state.game_provider;
        //listingArr.country_id = (this.props.currentUser?.country_id) || (this.props.userBasics?.country_id);
        //listingArr.merchant_id = (this.props.userBasics?.merchant_id);
        //listingArr.id = (this.props.userBasics?.id);
        listingArr.country_id = (this.props.currentUser?.country_id) || (this.props.userBasics?.country_id);
        listingArr.merchant_id = this.props.userBasics?.merchant_id;
        listingArr.id = this.props.userBasics?.id;

        listingArr.refer_member = this.state.refer_member;  // username from select
        console.log(listingArr)
        return listingArr;
    }

     userInfoArray = () =>{
        //const userInfoArr = {};
        // userInfoArr.page = this.state.activePage;
        // userInfoArr.limit = this.state.limit;
        //userInfoArr.id = this.props.currentUser.id;
        //userInfoArr.merchant_id = this.props.currentUser.merchant_id;
        //return userInfoArr;
        const u = this.props.currentUser || this.props.userBasics || {};
        return {
            id: u.id || u.aid || u.agent_id,
            merchant_id: u.merchant_id || u.merchantId,
        };
    } 



    
    datatablesChangeHandler = (val, tab, act) => {
        this.setState({
            data: [],
            loading: true,
            [act]: val
        }, () => {
            const listingArr = this.getFilterArray();
            this.props.funcGetList(listingArr);

            const userInfoArr = this.userInfoArray();
            this.props.funcGetDropDown(userInfoArr);
        });
    }

    //Mobile//

    toggleShowDateSelect = (e, show) => {
        if (this.state.showDateSelect === false) {
            document.body.classList.add('modal-open');
        } else {
            document.body.classList.remove('modal-open');
        }
        this.setState({
            showDateSelect: !this.state.showDateSelect,
        });
        if (show === 'startDate') {
            this.setState({
                showDate: 'startDate',
                selectedDate: this.state.start_date,
                disableSearchButton: false,
            })
        } else if (show === 'endDate') {
            this.setState({
                showDate: 'endDate',
                selectedDate: this.state.end_date,
                disableSearchButton: false,
            })
        }
    }
    onChangeDateHandler = (value) => {
        if (this.state.showDate === 'startDate') {
            this.setState({
                start_date: `${value.years}-${value.months}-${value.days}`,
            })
        } else if (this.state.showDate === 'endDate') {
            this.setState({
                end_date: `${value.years}-${value.months}-${value.days}`,
            })
        }
    }

    onChangeFilterDateHandler = (value, e) => {
        this.setState({
            currentFilterDate: value
        });
    }

    onResetHandler = () => {
        this.setState({
            selectedFilterType: '',
            game_type:'',
            game_provider:'',
            refer_member: '',
            historyTab: 'betting_summary',
            currentFilterDate: 0,
            start_date: moment().format("YYYY-MM-DD"),
            end_date: moment().format("YYYY-MM-DD"),
            transaction_date: "",
            spin: true
        }, () => {
            const listingArr = this.getFilterArray();
            this.props.funcGetList(listingArr);

            const userInfoArr = this.userInfoArray();
            this.props.funcGetDropDown(userInfoArr);
        });

        setTimeout(() => this.setState({ spin: false }), 2000);
    }

    render() {
        // console.log(this.state.total);
        const { t, i18n } = this.props;
        const icons = this.imageImport(require.context("../../assets/images/profile/icons", false, /\.(png|jpe?g|svg)$/));
        const providers = this.imageImport(require.context("../../assets/images/profile/provider-icon", false, /\.(png|jpe?g|svg)$/));
        const resetIcon = this.imageImport(
            require.context("../../assets/images/icons", false, /\.(png|jpe?g|svg)$/)
        );

        let inputArr = this.state.input ? this.state.input : [];
        let rsData = [];
        let gn_val = "";
        let downlineList = [];
        const num_format = { maximumFractionDigits: 2, minimumFractionDigits: 2 };

        const columns = [
            // { text: t('history.update-date'), dataField: 'update_date' },
            // { text: t('betting-history.refer-members-id'), dataField: 'refer_members_id' },
            // { text: t('vip.vip-level'), dataField: 'vip_level' },
            // { text: t('history.game-provider'), dataField: 'game_provider' },
            // { text: t('history.game-name'), dataField: 'gameName' },
            // { text: t('history.bet-amount'), dataField: 'bet_amount' },
            // { text: t('history.turnover'), dataField: 'turnover' },

   
            { 
                text: t('global.no'), 
                dataField: 'no',
                formatter: (cell, row, rowIndex) => {
                    let rowNumber = rowIndex + 1;
                    return <span>{rowNumber}</span>;
                } 
            },
            { 
                text: t('betting-history.member'), 
                dataField: 'agent',
                sort: true,
                onSort: this.onSort, 
            },
            { 
                text: t('betting-history.game-type'), 
                dataField: 'slug' 
            },
            { 
                text: t('betting-history.base-currency'), 
                dataField: 'currency' 
            },
            { 
                text: t('betting-history.total-bet'), 
                dataField: 'total_bet_base_currency' 
            },
            { 
                text: `${t('betting-history.total-bet')} (${t('global.currencies.usd')})`,
                dataField: 'total_bet' 
            },
        ];
        
        if (this.state.downline && !this.state.loading) {
            
			downlineList = this.state.downline.map((u) => {
				return {
					// username: val.username,
                    //id: val.id,
                    //label: val.username,
                    //key: idx,
                    value: u.username,   // what you send to backend (username)
                    label: u.username,   // what user sees
                    id: u.id,            // keep id if you need it later
				};
			});

		}

        if (this.state.data) {
            rsData = this.state.data.map((val, idx) => {
                if (val.gameCode !== null) {
                    if (val.title === null && i18n.exists(`games:${val.gameVendorSlug}.${val.gameCode}`)) {                        
                        gn_val = t(`games:${val.gameVendorSlug}.${val.gameCode}`);
                    }
                    else if (val.title === null && !i18n.exists(`games:${val.gameVendorSlug}.${val.gameCode}`)) {                        
                        gn_val = val.gameCode;
                    }
                    else {
                        gn_val = val.title;
                    } 
                } else {
                    gn_val = (val.result === 'bonus') ? t('history.bonus') : '';
                }

                return {
                    // update_date: val.update_date,
                    // refer_members_id: val.username,
                    // vip_level: val.group_id,
                    // game_provider: t(`vendor.${val.gameVendorSlug}`),
                    // gameName: gn_val,
                    // bet_count: val.bet_count,
                    // bet_amount: new Intl.NumberFormat("en-US", num_format).format(val.bet_amount),
                    // turnover: new Intl.NumberFormat("en-US", num_format).format(val.turnover),
     
                    agent: val.agent,
                    slug: t(`game-type.${val.slug}`),
                    currency: val.currency,
                    total_bet_base_currency: new Intl.NumberFormat('en-US', num_format).format(val.total_bet_base_currency),
                    total_bet: new Intl.NumberFormat('en-US', num_format).format(val.total_bet),
                    
                };
            });
        }

        const fadeUp = keyframes`
            from {
            opacity: 0;
            transform: translate3d(0, 50px ,0);
            }

            to {
            opacity: 1;
            transform: translate3d(0, 0, 0);
            }
        `;

        return (
            <Auxiliary>
                {isDesktop ? (
                    <section className="pf-dashboard">
                        <div className="x-container">
                            <SideBar />
                            <Reveal className="pf-fade-col" keyframes={fadeUp} duration={1000} triggerOnce>
                                <div className="row g-3">
                                    <div className="col-12">
                                        <div className="pd-card-col">
                                            <h4 className="mb-2">{t('sidebar.betting-history')}</h4>
                                            <div className="pd-content">
                                                <div className="filters-col history-n-filter"> 
                                                    <div className="filters-tp-panel row">
                                                        <div className="filters-tp-col col-5">
                                                        <label className="col-form-label"> {t('betting-history.member-account')}:</label>
                                                        <div className="input-group">

                                                             <ReactSelect
                                                                classNamePrefix="react-select"
                                                                className={`form-control p-0 border-0`}
                                                                placeholder={t("profile.search-by-word")}
                                                                name="refer_member"
                                                                options={this.state.memberOptions}
                                                                onChange={(opt) => {
                                                                    this.setState(
                                                                        {
                                                                            selectedMember: opt,
                                                                            refer_member: opt ? opt.value : '',
                                                                            memberId: opt ? opt.id : null
                                                                        },
                                                                        () => this.searchHandler()
                                                                    );
                                                                }}
                                                                value={this.state.selectedMember}
                                                                isLoading={this.state.memberLoading || this.state.memberLoadingMore}
                                                                loadingMessage={() => this.state.memberLoadingMore ? t("global.loading-more") + "..." : t("global.loading") + "..."}
                                                                onInputChange={this.onInputChangeMember}
                                                                onMenuScrollToBottom={this.onMenuScrollToBottom}
                                                                onMenuScroll={this.onMenuScroll}
                                                                onMenuOpen={this.onMenuOpen}
                                                                isClearable
                                                                isSearchable
                                                                noOptionsMessage={() => t("global.no-results-found")}
                                                            />
                                                        </div>
                                                        </div>
                                                        <div className="filters-tp-col col-5">
                                                        <div className="input-group">
                                                            <label className="col-form-label">{t('betting-history.game-provider')}:</label>
                                                            <ReactSelect
                                                                classNamePrefix="react-select"
                                                                className={`form-control p-0 border-0`}
                                                                placeholder={t("profile.search-by-word")}
                                                                name="game_provider"
                                                                options={gameProviders}
                                                                onChange={this.handleGameProviderChange}
                                                                value={(this.state.game_provider !== '') ? gameProviders[this.state.game_provider] : ''}
                                                                formatOptionLabel={(item) => (
                                                                    <>
                                                                        {/* {item.icon && <img src={(providers[`${item.icon}`])} alt={item.label} />} */}
                                                                        <p>{item.label}</p>
                                                                    </>
                                                                )}
                                                            />
                                                        </div>
                                                        </div>
                                                    </div>
                                                    <div className="filters-bt-panel">
                                                    
                                                        <div className="filters-bt-col">
                                                            <label className="col-form-label">{t("betting-history.type")}:</label>
                                                            
                                                            <div className="filters-group">
                                                                {gameCategories &&
                                                                    gameCategories.map((item, index) => (
                                                                        <div className="form-check form-check-inline filter" key={index}>
                                                                            <input
                                                                                className="btn-check"
                                                                                type="radio"
                                                                                name="game_type"
                                                                                id={item.id}
                                                                                value={item.value}
                                                                                defaultChecked={index === 0}
                                                                                checked={item.value === this.state.selectedFilterType}
                                                                                onClick={(e) => this.onInputChange(e)}
                                                                            />
                                                                            <label className="btn form-check-label" htmlFor={item.id}>
                                                                                {item.value === '' ? t(`global.all`) : t(`game-type.${item.value}`)}
                                                                            </label>
                                                                        </div>
                                                                    ))}
                                                            </div>
                                                            
                                                        </div>
                                                        <div className="filters-bt-col">
                                                            {/* <label className="col-form-lab
                                                            el">{t('history.time')}:</label> */}
                                                            <label className="col-form-label">{t('history.betting-time')}</label>
                                                            <div className="input-group right">
                                                                <DateTimePicker
                                                                    id="transaction_date"
                                                                    name="transaction_date"
                                                                    className="form-control"
                                                                    autoUpdateInput={true}
                                                                    autoApply={true}
                                                                    format="MM/DD/YYYY"
                                                                    value={this.state.transaction_date}
                                                                    onChange={this.onInputChange}
                                                                />
                                                                <span className="input-group-text">
                                                                    <Icon icon="uil:calendar-alt" />
                                                                </span>
                                                            </div>
                                                            <Button
                                                                typeButton="button"
                                                                classValue="btn btn-gradient-blue"
                                                                idValue="search"
                                                                buttonName={t('global.check')}
                                                                clicked={() => this.searchHandler(this.state.historyTab)}
                                                                disabled={this.state.disableSearchButton}
                                                            />
                                                            <div className="reset-btn">
                                                                <img className={`${this.state.spin ? "spin" : ""} `} src={resetIcon["rotate-icon.svg"]} alt="reset" onClick={this.onResetHandler} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="pd-card-col">
                                            <Fade duration={1000} triggerOnce>
                                                <DataTable
                                                    keyField="no"
                                                    data={rsData}
                                                    columns={columns}
                                                    activePage={this.state.activePage}
                                                    limit={this.state.limit}
                                                    totalItems={this.state.totalRecords}
                                                    paginationHandler={(val) => this.datatablesChangeHandler(val, 'betting_summary', "activePage")}
                                                    // sizePerPageHandler={(val) => this.datatablesChangeHandler(val, 'betting_summary', "limit")}
                                                    loading={this.state.loading}
                                                    hideSearchBar={true}
                                                    hideTotalRecords={true}
                                                    classValue="pd-table"
                                                    component="betting-history"
                                                />
                                            </Fade>
                                        </div>
                                    </div>
                                </div>
                            </Reveal>
                        </div>
                    </section>
                ) : (
                    <MobileBettingHistory
                        gameCategories={gameCategories}
                        gameProviders={gameProviders}
                        filterDate={filterDate}
                        onInputChange={this.onInputChange}
                        filterDayRange={this.filterDayRange}

                        icons={icons}
                        num_format={num_format}
                        rsData={rsData}
                        columns={columns}

                        searchHandler={this.searchHandler}
                        datatablesChangeHandler={this.datatablesChangeHandler}

                        onChangeDateHandler={this.onChangeDateHandler}
                        toggleShowDateSelect={this.toggleShowDateSelect}
                        handleGameProviderChange={this.handleGameProviderChange}
                        downlineList={downlineList}
                        handleMemberReferChange={this.handleMemberReferChange}

                        onResetHandler={this.onResetHandler}
                        onChangeFilterDateHandler={this.onChangeFilterDateHandler}

                        // Member search functionality
                        memberOptions={this.state.memberOptions}
                        selectedMember={this.state.selectedMember}
                        memberLoading={this.state.memberLoading}
                        memberLoadingMore={this.state.memberLoadingMore}
                        onInputChangeMember={this.onInputChangeMember}
                        onMenuScrollToBottom={this.onMenuScrollToBottom}
                        onMenuScroll={this.onMenuScroll}
                        onMenuOpen={this.onMenuOpen}

                        {...this.state}
                        {...this.props}
                    />
                )
                }
            </Auxiliary>
        );
    }
}

//Received the response from the redux calling the api response
const mapStateToProps = state => {
    return {
        rs: state.bettingHistory.rs,
        cancel: state.bettingHistory.cancel,
        currentUser: state.currentUser.data,
        //userBasics: state.userBasics?.data,
        userBasics: state.bettingHistory?.userBasics,
        dropDown: state.bettingHistory.dropDown,
    }
};

//Using the redux calling api methods
const mapDispatchToProps = dispatch => {
    return {
        funcGetList: (filter) => dispatch(actions.getList(filter)),
        funcGetDropDown: (userInfo) => dispatch(actions.getDropDown(userInfo)),
        fetchUserBasicsFromLocal: () => dispatch(actions.fetchUserBasicsFromLocal()),
    }
};

// Connect redux
export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces('translation')(BettingHistory));
